import { createReducer } from "@reduxjs/toolkit";
import {
  setIsSubmittedRiskAnalysis,
  updateHasAnyRAChange,
  updateSaveAndCompleteRiskAnalysis,
} from "./riskAnalysisProcessActions";
import {
  loadingList,
  setProcedureId,
} from "./riskAnalysisQuestionnaireActions";

export interface IRskAnalysisProcessReducerState {
  dataCount: number;
  isLoading: boolean;
  hasAnyChange: boolean;
  ProcedureId: number;
  saveAndCompleteRA: boolean;
  isSubmittedRiskA: boolean;
}

const initialState: IRskAnalysisProcessReducerState = {
  dataCount: 0,
  isLoading: false,
  hasAnyChange: false,
  saveAndCompleteRA: false,
  ProcedureId: 0,
  isSubmittedRiskA: false,
};

export const riskAnalysisProcessReducer = createReducer(
  initialState,
  (builder) => {
    builder

      .addCase(updateHasAnyRAChange, (state, action) => {
        state = {
          ...state,
          hasAnyChange: action.payload,
        };
        return state;
      })
      .addCase(setIsSubmittedRiskAnalysis, (state, action) => {
        state = {
          ...state,
          isSubmittedRiskA: action.payload,
        };
        return state;
      })
      .addCase(loadingList, (state, action) => {
        state = {
          ...state,
          isLoading: action.payload,
        };
        return state;
      })
      .addCase(setProcedureId, (state, action) => {
        state = {
          ...state,
          ProcedureId: action.payload,
        };
        return state;
      })
      .addCase(updateSaveAndCompleteRiskAnalysis, (state, action) => {
        state = {
          ...state,
          saveAndCompleteRA: action.payload,
        };
        return state;
      });
  }
);
